import React from "react";
import Navigator from "./navigation";
import { AppProvider } from "./context/app.context";
import { BrowserRouter } from "react-router-dom";
import AlertContainer from "./component/alerts/alert.container";
import { AlertProvider } from "./component/alerts/alert.context";

const App = () => {

    return (
        <AppProvider>
            <BrowserRouter>
                <AlertProvider>
                    <Navigator />
                    <AlertContainer position="top" />
                </AlertProvider>
            </BrowserRouter>
        </AppProvider>
    );
}

export default App;